import { Outlet, Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

import { APP_NAME } from "@/lib/constants";

export function AuthLayout() {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-gradient-to-br from-brand-800 via-brand-900 to-surface-950 text-white relative overflow-hidden">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-500/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-brand-400/20 rounded-full blur-3xl" />
        <Link to="/" className="flex items-center gap-3 z-10">
          <div className="w-11 h-11 rounded-xl bg-white/10 backdrop-blur grid place-items-center">
            <Sparkles className="w-6 h-6" />
          </div>
          <div className="text-lg font-bold">{APP_NAME}</div>
        </Link>
        <div className="relative z-10 space-y-4 max-w-md">
          <h1 className="text-4xl font-bold leading-tight">
            Enterprise-grade club management.
          </h1>
          <p className="text-white/70 text-base leading-relaxed">
            Track qualifications, memberships, placements, stages, rewards, and wallet
            activity — all in real time — with immutable audit and full traceability.
          </p>
          <div className="grid grid-cols-3 gap-4 pt-6">
            {[
              ["20+", "Engines"], ["100%", "Audited"], ["Zero", "Downtime"],
            ].map(([n, l]) => (
              <div key={l} className="border border-white/10 rounded-lg p-3">
                <div className="text-xl font-bold">{n}</div>
                <div className="text-2xs uppercase text-white/60 tracking-wide">{l}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="text-xs text-white/40 z-10">© {new Date().getFullYear()} Auto Club Enterprise</div>
      </div>
      <div className="flex items-center justify-center p-6 lg:p-12 bg-surface-50">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
